import { useMonth } from "@datepicker-react/hooks";
import { Box, IconButton, Typography, useTheme } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { Maybe } from "../../models/common/generic-types";
import Day from "./Day";

interface MonthProps {
	year: number;
	month: number;
	startDate?: Maybe<Date>;
	endDate?: Maybe<Date>;
	index: number;
	goToPreviousMonths: () => void;
	goToNextMonths: () => void;
	handleSelectDay: (date: Date) => void;
}

const Month: React.FC<MonthProps> = ({ year, month, startDate, endDate, index, goToPreviousMonths, goToNextMonths, handleSelectDay }) => {
	const { spacing } = useTheme();
	const { days, weekdayLabels, monthLabel } = useMonth({
		year,
		month,
		firstDayOfWeek: 1,
	});

	return (
		<Box>
			<Box display="flex" justifyContent="space-between">
				{index === 0 && (
					<IconButton style={{ justifySelf: "flex-start" }} onClick={goToPreviousMonths}>
						<ChevronLeft />
					</IconButton>
				)}
				<Typography
					color="textSecondary"
					style={{
						paddingTop: spacing(1.6),
						marginRight: index === 0 ? spacing(8) : "0px",
						marginLeft: index === 1 ? spacing(8) : "0px",
					}}
				>
					{monthLabel}
				</Typography>
				{index === 1 && (
					<IconButton onClick={goToNextMonths}>
						<ChevronRight />
					</IconButton>
				)}
			</Box>
			<Box
				display="grid"
				gridTemplateColumns="repeat(7, 1fr)"
				justifyContent="center"
				marginBottom={spacing(0.1)}
				marginTop={spacing(0.3)}
			>
				{weekdayLabels.map((dayLabel) => (
					<Typography color="textSecondary" align="center" variant="caption" key={dayLabel}>
						{dayLabel.substr(0, 1)}
					</Typography>
				))}
			</Box>
			<Box display="grid" gridTemplateColumns="repeat(7, 1fr)" justifyContent="center">
				{days.map((day, index) => {
					if (typeof day === "object") {
						return (
							<Box key={day.date.getTime()} bgcolor={"white"}>
								<Day
									date={day.date}
									dayLabel={day.dayLabel}
									startDate={startDate}
									endDate={endDate}
									handleSelectDay={handleSelectDay}
								/>
							</Box>
						);
					}

					return <Box key={index} />;
				})}
			</Box>
		</Box>
	);
};

export default Month;
